import { from, merge, of } from 'rxjs'
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  mergeMap,
  switchMap,
  // tap,
} from 'rxjs/operators'
import { useObservable } from 'rxjs-hooks'

import { IncrementalSearchProps, IncrementalSearchResult } from './interface'

export const now = () => new Date().getTime()

export function IncrementalSearch({
  inputValue,
  search,
  submit$,
  children,
  searchWaitMs,
}: IncrementalSearchProps) {
  const data = useObservable<IncrementalSearchResult, string[]>(
    (_, inputValue$) => {
      return merge(
        inputValue$.pipe(
          map(v => v[0]),
          filter(v => !!v && v.length > 1),
          distinctUntilChanged(),
          // tap(v => console.log('input4', v)),
          debounceTime(searchWaitMs),
          // tap(v => console.log('input5', v)),
          map(v => ({ value: v, time: now() }))
        ),
        submit$.pipe(
          // tap(v => console.log('submit1', v)),
          filter(v => typeof v !== 'undefined'),
          // tap(v => console.log('submit2', v)),
          distinctUntilChanged(),
          // tap(v => console.log('submit3', v)),
          mergeMap(() => inputValue$.pipe(map(v => ({ value: v[0], time: now() }))))
        )
      ).pipe(
        distinctUntilChanged((a, b) => a.time === b.time && a.value === b.value),
        map(({ value }) => ({
          search: search(value),
          inputValue: value,
        })),
        // tap(v => console.log('before query', v)),
        switchMap(({ search, inputValue }) =>
          from(search).pipe(map(res => ({ result: res, inputValue })))
        ),
        // tap(v => console.log('after query', v)),
        map(({ result }) => {
          return { ...result, done: true }
        }),
        catchError(_ => of({ data: { queryFAQ: [] }, done: true, error: true }))
      )
    },
    { data: { queryFAQ: [] }, done: false },
    [inputValue]
  )

  return children(data)
}
